import{createContext as a}from"react";var r=a({tabSize:"S",variant:"flat",tabBackground:"WHITE"});export{r as TabsContext};
